import BaseHelper from './BaseHelper'
import { select as d3_select } from 'd3-selection'
export default class SelectableHelper extends BaseHelper {
  static configName = 'SelectableHelper'

  static defaultConfig = {
    index: 103,
    /**
     * Enable/disable selection of the items. When enabled, items will be highlighted on click/tap.
     */
    enableSelection: {
      type: Boolean,
      default: true,
      exposed: true,
    },
  }
  static init() {
    this.selection = []
    let self = this
    d3_select(this.$root).on('click', (e, d) => {
      if (e.currentTarget === e.target) {
        self.selection = []
        self.$root.dispatchEvent(new MouseEvent('mouseover'))
        self._updateSelection()
      }
    })
  }
  static afterDraw() {
    let enters = this.itemsEnter
    let self = this
    if (enters) {
      enters.on('click', (e, d) => {
        if (d.parentId) {
          if (self.data.lines) {
            d =
              self.data.lines.find(dd => dd.id === d.parentId) ||
              self.data.bars.find(dd => dd.id === d.parentId)
          } else {
            d = self.data.find(dd => dd.id === d.parentId)
          }
        }
        self._setSelection(e, d)
        e.currentTarget.dispatchEvent(new MouseEvent('mousemove'))
        e.target.dispatchEvent(new MouseEvent('mousemove'))
      })
    }
    // update para cuando cambiamos la prop (no podemos hacer siempre xk se estropean las transitions...)
    if (!this.config.SelectableHelper.enableSelection && this.selection.length)
      this._updateSelection()
  }
  static _updateSelection = function () {
    if (!this.config.SelectableHelper.enableSelection) this.selection = []

    let items =
      (this.parentItems && this.parentItems.merge(this.parentItemsEnter)) ||
      (this.items && this.items.merge(this.itemsEnter)) ||
      (this.linesItems && this.linesItems.merge(this.linesItemsEnter))

    let self = this
    if (this.selection.length) {
      let trans = items
        .transition('select-trans')
        .duration(200)
        .style('opacity', dd => (this.selection.indexOf(dd) >= 0 ? 1 : 0.3))

      if (this.setSelectedFunc) {
        trans.each(function (dd) {
          if (self.selection.indexOf(dd) >= 0)
            d3_select(this).call(self.setSelectedFunc.bind(self), dd)
          else d3_select(this).call(self.unsetSelectedFunc.bind(self), dd)
        })
      }
    } else {
      let trans = items.transition('select-trans').duration(200).style('opacity', 1)

      if (this.unsetSelectedFunc) {
        trans.each(function (dd) {
          d3_select(this).call(self.unsetSelectedFunc.bind(self), dd)
        })
      }
    }
    this.emit('select', this.selection)
  }
  static _setSelection = function (e, d) {
    if (this.selection.indexOf(d) >= 0) this.selection = this.selection.filter(dd => dd !== d)
    else this.selection = [d] //this.selection.push(d)

    this._updateSelection()
  }

  static selectById = function (id) {
    this._setSelection(
      null,
      this.data.find(d => d.id === id)
    )
  }
}
